import preq from '#app/lib/preq'
import { objectEntries } from '#app/lib/utils'
import type { RelativeUrl } from '#server/types/common'
import type { ControllersAPI } from '#server/types/controllers_api'

/** Typed HTTP requests to /api/* endpoints */
export async function treq <
  Section extends keyof ControllersAPI,
  Method extends keyof ControllersAPI[Section],
  Action extends keyof ControllersAPI[Section][Method],
  Controller extends ControllersAPI[Section][Method][Action],
>
// @ts-expect-error
(section: Section, method: Method, action: Action, params: Controller['params'] = {}): Promise<Controller['response']> {
  let pathname = `/api/${section}`
  if (action !== 'default') pathname += `/${action as string}`
  if (method === 'get' || method === 'delete') {
    const urlParams = new URLSearchParams()
    // @ts-expect-error
    addParams(urlParams, params)
    const url = urlParams.size > 0 ? `${pathname}?${urlParams.toString()}` : pathname
    // @ts-expect-error
    return preq[method](url)
  } else {
    // @ts-expect-error
    return preq[method](pathname, params)
  }
}

function addParams (urlParams: URLSearchParams, params: Record<string, string | number | string[] | number[]>) {
  for (const [ key, value ] of objectEntries(params)) {
    if (value instanceof Array) {
      urlParams.append(key, value.join('|'))
    } else if (value !== undefined) {
      urlParams.append(key, value.toString())
    }
  }
}

export function treqPartial <
  Section extends keyof ControllersAPI,
  Method extends keyof ControllersAPI[Section],
  Action extends keyof ControllersAPI[Section][Method],
>
(section: Section, method: Method, action: Action) {
  // @ts-expect-error
  return function (params: ControllersAPI[Section][Method][Action]['params'] = {}) {
    return treq(section, method, action, params)
  }
}

export function buildApiUrl <
  Section extends keyof ControllersAPI,
  Method extends keyof ControllersAPI[Section],
  Action extends keyof ControllersAPI[Section][Method],
  Controller extends ControllersAPI[Section][Method][Action],
>
// @ts-expect-error
(section: Section, method: Method, action: Action, params: Controller['params'] = {}): RelativeUrl {
  let pathname = `/api/${section}` as RelativeUrl
  if (action !== 'default') pathname += `/${action as string}`
  const urlParams = new URLSearchParams()
  // @ts-expect-error
  addParams(urlParams, params)
  return urlParams.size > 0 ? `${pathname}?${urlParams.toString()}` : pathname
}
